import { useEffect, useMemo, useState } from 'react';

// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { useAuth } from 'contexts/AuthContext';

const VALID_ROLES = ['manager', 'planner', 'operator'];

const normalizeRole = (value) => (VALID_ROLES.includes(value) ? value : 'operator');

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const { user, erpRole } = useAuth();
  const [role, setRole] = useState(normalizeRole(erpRole || 'operator'));

  useEffect(() => {
    const readRole = () => {
      const profileRole = user?.user_metadata?.erp_role;
      const nextRole = normalizeRole(erpRole || profileRole || 'operator');
      if (typeof window !== 'undefined' && window.localStorage.getItem('erp_role') !== nextRole) {
        window.localStorage.setItem('erp_role', nextRole);
      }
      setRole(nextRole);
    };

    readRole();
    window.addEventListener('storage', readRole);
    window.addEventListener('erp-role-changed', readRole);

    return () => {
      window.removeEventListener('storage', readRole);
      window.removeEventListener('erp-role-changed', readRole);
    };
  }, [erpRole, user?.user_metadata?.erp_role]);

  const filterByRole = (node, activeRole) => {
    if (Array.isArray(node.roles) && node.roles.length > 0 && !node.roles.includes(activeRole)) {
      return null;
    }

    if (!node.children) return node;

    const nextChildren = node.children
      .map((child) => filterByRole(child, activeRole))
      .filter(Boolean);

    if (node.type === 'collapse' && nextChildren.length === 0) {
      return null;
    }

    return {
      ...node,
      children: nextChildren
    };
  };

  const visibleGroups = useMemo(
    () =>
      menuItem.items
        .map((group) => filterByRole(group, role))
        .filter(Boolean),
    [role]
  );

  const navGroups = visibleGroups.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
